import { InputBase, withStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import React from 'react';
import ArrowDown from 'utils/images/arrow-down.svg';

const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing.unit * 3,
    },
  },
  input: {
    borderRadius: 49,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #dddddd',
    fontSize: 13,
    width: 'auto',
    padding: '10px 36px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'Basier Circle',
    '&:focus': {
      borderRadius: 49,
      borderColor: '#000',
      backgroundColor: '#fff',
    },
  },
}))(InputBase);

const FormSelectField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <FormControl
      className={custom.className}
      style={{
        ...(custom.inline
          ? {
              marginTop: 0,
              display: 'flex',
              alignItems: 'center',
              height: '40px',
            }
          : { marginTop: 16 }),
        ...(custom.fullWidth ? { width: '100%' } : {}),
      }}
    >
      {!custom.inline && <InputLabel htmlFor={custom.id}>{label}</InputLabel>}
      <Select
        className="form__selector"
        value={custom.value}
        error={!!(touched && error)}
        input={<BootstrapInput />}
        IconComponent={() => (
          <img alt="" className="form__selector__icon" src={ArrowDown} />
        )}
        {...input}
        {...custom}
      />
    </FormControl>
  );
};

export const StandaloneSelectField = ({ input, label, ...custom }) => {
  return (
    <FormControl className={custom.className} style={{ marginTop: 16 }}>
      <InputLabel shrink={true} htmlFor={custom.id}>
        {label}
      </InputLabel>
      <Select
        className="form__selector"
        value={custom.value}
        input={<BootstrapInput />}
        IconComponent={() => (
          <img alt="" className="form__selector__icon" src={ArrowDown} />
        )}
        {...input}
        {...custom}
      />
    </FormControl>
  );
};

export default FormSelectField;



// WEBPACK FOOTER //
// ./src/components/FormElements/FormSelectField.jsx